import React, { forwardRef } from 'react';

type OwnProps = React.PropsWithoutRef<React.SVGProps<SVGSVGElement>>;

export default forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM3.75736 7.25C3.34315 7.25 3.00736 7.58579 3.00736 8C3.00736 8.41421 3.34315 8.75 3.75736 8.75H10.432L8.88388 10.2981C8.59099 10.591 8.59099 11.0659 8.88388 11.3588C9.17678 11.6517 9.65165 11.6517 9.94454 11.3588L12.773 8.53033C13.0659 8.23744 13.0659 7.76256 12.773 7.46967L9.94454 4.64124C9.65165 4.34835 9.17678 4.34835 8.88388 4.64124C8.59099 4.93414 8.59099 5.40901 8.88388 5.7019L10.432 7.25L3.75736 7.25Z"
      fill="#183558"
    />
  </svg>
));
